import React, { useEffect, useState, useRef } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData, updateSortDirection } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import PatientService from "../services/patient-service";
import facilityService from "../services/facility-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Multiselect } from "multiselect-react-dropdown";
import { Modal } from "react-responsive-modal";
import { selectUsers } from "../state/reducers/userSlice";
import {
  clearPatId,
  updatePatId,
  updatePatIdForOrder,
  updatePatIdForRefill,
  getPatId,
  updateOrders,
  clearOrders,
} from "../state/reducers/patientSlice";
import moment from "moment";
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";
import marPrinterService from "../services/marPrinterService";

const tablePropsInit = {
  columns: [
    { key: "select", title: "Select", style: { width: "100px" } },
    { key: "fac_name", title: "Facility", isSortable: true },
    { key: "profiled", title: "Status", isSortable: true },
    { key: "rxf_number", title: "Rx Number", style: { width: "100px" }, isSortable: true },
    { key: "drg_name", title: "Drug", isSortable: true },
    { key: "rxf_sig", title: "Sig", isSortable: true },
    { key: "last_fill_date", title: "Last Fill", isSortable: true },
    { key: "fil_qty_dsp", title: "Qty", isSortable: true },
    { key: "rxf_ref_left", title: "Refills Remaining", style: { width: "100px" }, isSortable: true },
    { key: "doc_name", title: "Doctor", isSortable: true },
    { key: "start_date", title: "Start Date", style: { width: "100px" }, isSortable: true },
    { key: "stop_date", title: "Stop Date", style: { width: "100px" }, isSortable: true },
    { key: "shp_date", title: "Ship Date", style: { width: "100px" }, isSortable: true },
    { key: "action", title: "Action", style: { width: "100px" } },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "userId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitInactive = {
  columns: [
    { key: "script_view", title: "Script Details", style: { width: "100px" } },
    { key: "fac_name", title: "Facility", isSortable: true },
    { key: "rxf_number", title: "Rx Number", style: { width: "100px" }, isSortable: true },
    { key: "rxf_ref_left", title: "Refills Remaining", style: { textAlign: "center", width: "100px" }, isSortable: true },
    { key: "start_date", title: "Start Date", style: { width: "100px" }, isSortable: true },
    { key: "stop_date", title: "Stop Date", style: { width: "100px" }, isSortable: true },
    { key: "last_fill_date", title: "Last Fill", style: { width: "100px" }, isSortable: true },
    { key: "profiled", title: "Status", isSortable: true },
    { key: "drg_name", title: "Drug", isSortable: true },
    { key: "rxf_sig", title: "Sig", isSortable: true },
    { key: "doc_name", title: "Doctor", isSortable: true },
    { key: "shp_date", title: "Ship Date", isSortable: true },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "userId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const tablePropsInitOrderDetails = {
  columns: [
    { key: "rx_number", title: "RX" },
    { key: "fac_code", title: "Facility Code" },
    { key: "seq_number", title: "Sequence" },
    { key: "fill_date", title: "Fill Date" },
    { key: "drug", title: "Drug", style: { width: "200px" } },
    { key: "ship_date", title: "Ship Date" },
    { key: "scanned_user", title: "Scanned User" },
    { key: "actions", title: "Actions", style: { display: "none" } },
    { key: "received_datetime", title: "Received" }
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "rx_number",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 5,
    position: PagingPosition.Bottom,
  },
};
const PatientDetails = ({ history }) => {
  const location = useLocation();
  const state = location.state;

  const [loading, setLoading] = useState(false);
  let { patId } = useSelector(getPatId);
  const { user } = useSelector(selectUsers);
  const dispatch1 = useDispatch();
  const [patientsList, setPatientsList] = useState();
  const [showList, setShowList] = useState("hidden");
  const [patName, setPatName] = useState("");
  const [patDob, setPatDob] = useState("");
  const [patLocation, setPatLocation] = useState("");
  const [patient, setPatient] = useState([]);
  const [patientId, setPatId] = useState("");
  const [tabIndex, setTabIndex] = useState(1);
  const multiselectRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const patClearedRef = useRef(false);
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [tablePropsInactive, changeTablePropsInactive] = useState(tablePropsInitInactive);
  const [tablePropsOrderDetails, changeTablePropsOrderDetails] = useState(tablePropsInitOrderDetails);
  const [orderList, setOrderList] = useState([]);
  const [discontinueOpen, setDiscontinueOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  const normalizeSearch = (value = "") => {
    if (typeof value !== "string") return "";
    return value
      .replace(/,\s*/g, ", ")
      .replace(/\s+/g, " ")
      .trim();
  };

  const handleSearchPatients = async (value) => {
    setSearchText(value);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!value || !value.trim()) {
      setPatientsList([]);
      setShowList("hidden");
      await patients();
      return;
    }

    searchTimeoutRef.current = setTimeout(async () => {
      const normalized = normalizeSearch(value);
      try {
        setLoading(true);
        const resp = await PatientService.getPatients(normalized);
        const data = resp?.response || resp?.list || [];
        const formattedList = data.map((res) => ({
          id: res.id,
          name: `${res.lname.toUpperCase()}, ${res.fname.toUpperCase()}${
            res.acct_number ? ` (${res.acct_number})` : ""
          }`,
          fname: res.fname,
          lname: res.lname,
          acct_number: res.acct_number,
          dob: res.dob,
          location: res.location,
          accountNumber: res.acct_number,
          fac_dcode: res.fac_dcode,
        }));
        setPatientsList([]);
        setTimeout(() => setPatientsList(formattedList), 0);
        setLoading(false);
      } catch (error) {
        setPatientsList([]);
        setLoading(false);
      }
    }, 300);
  };

  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };
  const dispatchInactive = async (action) => {
    changeTablePropsInactive((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };

  const dispatchOrderDetails = async (action) => {
    changeTablePropsOrderDetails((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };
  async function getPatDetails(actnType, selectedPatientDetails) {
    let patDetails =
      multiselectRef.current && multiselectRef.current.getSelectedItems();
    if (actnType === undefined) {
      if (selectedPatientDetails?.length > 0) {
        patDetails = selectedPatientDetails;
      } else {
        patDetails = patient?.length > 0 ? patient : patId;
      }
    }

    try {
      setLoading(true);
      let resp = await PatientService.getPatientDrugs(patDetails.length ? patDetails[0].id : selectedPatientDetails[0].id);
      resp.sort(
        (d1, d2) =>
          new Date(d2.start_date).getTime() - new Date(d1.start_date).getTime()
      );

      let activeItems = resp?.filter(item => item?.status === 'ACTIVE');
      setOrderList(activeItems);
      dispatch(updateData(activeItems));
      dispatchInactive(updateData(resp?.filter(item => item?.status === 'INACTIVE')));
      setShowList("show");
      if (resp.length > 0) {
        setPatName(resp[0].pat_name);
        setPatId(resp[0].pat_acct_number);
        setPatDob(resp[0].pat_dob);
      } else {
        dispatch(updateData([]));
        dispatchInactive(updateData([]));
        setPatName(
          patDetails[0].name || patId[0]?.lname + ", " + patId[0]?.fname
        );
        setPatId(patDetails[0].accountNumber);
        setPatDob(moment(patDetails[0].dob).format("MM/DD/YYYY"));
      }
      setPatLocation(patDetails?.length ? patDetails[0]?.location : selectedPatientDetails?.[0]?.location);
      setLoading(false);
      document.getElementById("search_input").blur();
    } catch (e) {
      setLoading(false);
    }
  }

  const CustomCellNewCheckbox = ({ rowData }) => {
    return (
      <div key={rowData.rowData.rxf_number}>
        <input
          type="checkbox"
          id={rowData.rowData.rxf_number}
          disabled={rowData.rowData.rxf_id === 0}
          checked={rowData.rowData["selected"]}
          onChange={(e) => {
            const selectedItem = orderList.findIndex(
              (item) => item.rxf_number === rowData.rowData.rxf_number
            );
            orderList[selectedItem]["selected"] = e.target.checked;
            dispatch(updateData(orderList));
          }}
        />
      </div>
    );
  };
  const [openPopUp, setOpenPopUp] = useState(false);
  const onCloseModal = async () => {
    setOpenPopUp(false);
    dispatchOrderDetails(updateData([]));
  }
  const CustomCellAction = ({ rowData }) => {
    return (
      <div className="action_btns" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span className="inline-block cursor-pointer" title="Script Details">
          <img
            src="./img/info_icon.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              handleViewScript(rowData?.rowData?.rxf_id);
            }}
            alt="Script Details"
          />
        </span>
        <span className="inline-block cursor-pointer" title="Print MAR Label">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="m-auto w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            onClick={() => handlePrintMarLabel(rowData?.rowData)}
          >
            <polyline points="6 9 6 2 18 2 18 9" />
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
            <rect x="6" y="14" width="12" height="8" />
          </svg>
        </span>
      </div>
    );
  };

  const handleViewScript = async (rxf_id) => {
    try {
      setLoading(true);
      const resp = await PatientService.getOrderDetails(rxf_id);
      dispatchOrderDetails(updateData(resp));
      setOpenPopUp(true);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }
  const handleProceed = async () => {
    try {
      setLoading(true);
      var items = orderList.filter((item) => item["selected"] === true);
      dispatch1(updateOrders(items));
      dispatch1(updatePatIdForRefill(patient));
      dispatch1(updatePatId(patient));
      await history.push("/refill");
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleReleaseMedication = async () => {
    try {
      var items = orderList.filter((item) => item["selected"] === true)
        .map((item) => ({ ...item, pat_id: patient[0].id }));

      if (items.length) {
        dispatch1(updatePatId(patient));
        await history.push("/releaseMedication", items);
      }
      else {
        const { hide } = cogoToast.error("Please Select at least one Medication", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const handleRenewMedication = async () => {
    try {
      var items = orderList.filter((item) => item["selected"] === true)
        .map((item) => ({ ...item, pat_id: patient[0].id }));

      if (items.length) {
        dispatch1(updatePatId(patient));
        await history.push("/renewMedication", items);
      }
      else {
        const { hide } = cogoToast.error("Please Select at least one Medication", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const handlePrintMarLabel = async (rowItem) => {
    try {
      const selectedItem = rowItem;
      if (!selectedItem) {
        cogoToast.error("Please select a medication to print");
        return;
      }
      setLoading(true);

      // Check if ZebraBrowserPrintWrapper is available
      if (typeof ZebraBrowserPrintWrapper === 'undefined') {
        const install = window.confirm(
          "Zebra Browser Print is not installed. Would you like to download it now?\n\n" +
          "After installation, please restart your browser and try again.\n\n" +
          "Download Link: https://www.zebra.com/ap/en/support-downloads/software/printer-software/browser-print.html"
        );
        if (install) {
          window.open("https://www.zebra.com/ap/en/support-downloads/software/printer-software/browser-print.html", "_blank");
        }
        setLoading(false);
        return;
      }
      const browserPrint = new ZebraBrowserPrintWrapper();

      try {
        const defaultPrinter = await browserPrint.getDefaultPrinter();
        if (!defaultPrinter) {
          throw new Error("No default printer found. Please set up a default printer in your system.");
        }
        browserPrint.setPrinter(defaultPrinter);
        const printerStatus = await browserPrint.checkPrinterStatus();
        if (printerStatus.isReadyToPrint) {
          const itemToPrint = { ...selectedItem };
          if (!itemToPrint.last_fill_date || new Date(itemToPrint.last_fill_date).getFullYear() === 1899) {
            itemToPrint.last_fill_date = "";
          }
          const resp = await marPrinterService.getMARPrintLabelText(itemToPrint);
          if (!resp) {
            throw new Error("Failed to generate label content");
          }
          const zpl = resp;

          await browserPrint.print(zpl);
          cogoToast.success("Label sent to printer successfully");
        } else {
          throw new Error(`Printer is not ready. Status: ${printerStatus.errors?.join(', ') || 'Unknown error'}`);
        }
      } catch (printError) {
        console.error("Printing error:", printError);
        throw printError;
      }
    } catch (error) {
      console.error("Error in handlePrintMarLabel:", error);
      cogoToast.error(`Printing failed: ${error.message || 'Unknown error occurred'}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDiscontinue = async () => {
    try {
      var items = orderList.filter((item) => item["selected"] === true);

      if (items.length !== 0) {
        var list = items?.map((item) => item.rxf_id);
        setLoading(true);
        await PatientService.discontinueOrder(list);
        getPatDetails();
        setLoading(false);
      } else {
        setLoading(false);
        const { hide } = cogoToast.error("No orders selected", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        return;
      }
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error processing request. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const patients = async () => {
    try {
      setLoading(true);
      const resp = await PatientService.getPatients("", 30);
      const data = resp?.list || [];
      if (data.length) {
        let finalArray = data.map((res) => {
          let patCode = res.acct_number ? " (" + res.acct_number + ")" : "";
          return {
            id: res.id,
            name: res.lname + ", " + res.fname + patCode,
            fname: res.fname,
            lname: res.lname,
            acct_number: res.acct_number,
            dob: res.dob,
            location: res.location,
            accountNumber: res.acct_number,
            fac_dcode: res.fac_dcode,
          };
        });
        setPatientsList(finalArray);
        if (!patClearedRef.current) {
          if (state && state.pat_id) {
            let selectedPatId = finalArray.filter((item) => item.id === state.pat_id);
            setPatient(selectedPatId);
            getPatDetails(undefined, selectedPatId)
          }
          if (patId?.length > 0) {
            let patSeleted = finalArray.filter((item) => item.id === patId[0].id);
            if (patSeleted.length > 0) {
              setPatient(patSeleted);
            } else {
              const formattedPatId = patId.map(p => ({
                ...p,
                name: `${p.lname?.toUpperCase()}, ${p.fname?.toUpperCase()}${p.acct_number ? ` (${p.acct_number})` : ''}`,
                accountNumber: p.acct_number,
                fac_dcode: p.fac_dcode,
              }));
              setPatientsList([...formattedPatId, ...finalArray]);
              setPatient(formattedPatId);
            }
          }
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  useEffect(() => {
    patients();
    getAccessForFacility();
    if (patId?.length > 0) {
      getPatDetails();
    }
  }, []);
  useEffect(() => {
    getAccessForFacility();
  }, [user?.facility]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const onDisContinueCloseModal = () => {
    setDiscontinueOpen(false);
  };

  const [access, setAccess] = useState({});
  const getAccessForFacility = async () => {
    try {
      let resp = await facilityService.getAccessForFacilities(user?.facility);
      setAccess(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={openPopUp} onClose={onCloseModal} center styles={{ modal: { maxWidth: "900px", "overflowy": "scroll" } }}>
        <div className="pt-4 px-4 pb-4 ">
          <h3
            className="text-lg leading-6 font-bold text-lg text-gray-900 pb-2 pl-2"
            id="modal-headline"
          >
            Script Details
          </h3>
          <div className="p-2 text-xs usersList gridList overflow-x-auto">
            <Table
              {...tablePropsOrderDetails}
              childComponents={{
                cellText: {
                  content: (props) => {
                  },
                },
              }}
              dispatch={dispatchOrderDetails}
            />
          </div>
        </div>
      </Modal>
      <div className="bg-white w-11/12 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">PATIENT MEDICATIONS</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="w-3/4 inline-block mr-4 pl-4">
              <Multiselect
                name="patient"
                displayValue="name"
                options={patientsList || []}
                selectedValues={patient}
                selectionLimit={1}
                placeholder="Search Patient"
                hidePlaceholder
                HighlightFirstOption
                onSearch={handleSearchPatients}
                closeOnSelect={true}
                onSelect={(list, item) => {
                  setPatient([item]);
                  getPatDetails(undefined, [item]);
                  dispatch1(clearPatId());
                  dispatch1(clearOrders());
                }}
                onRemove={async () => {
                  patClearedRef.current = true;
                  setPatient([]);
                  setPatientsList([]);
                  setShowList("hidden");
                  setSearchText("");
                  dispatch1(clearPatId());
                  await patients();
                }}
              />
            </span>
          </div>
        </div>
        <div className={`flex items-center justify-between w-full py-2 text-xs patientDetails ${showList}`}>
          {/* Patient Details - Left Aligned */}
          <div className="flex-1">
            <ul className="flex flex-wrap">
              <li className="inline-flex items-center text-black pl-3">
                <span className="text-xs md:text-base font-bold">NAME:</span>
                <span className="text-xs md:text-sm ml-1">{patName}</span>
              </li>
              <li className="inline-flex items-center text-black pl-3 ml-4">
                <span className="text-xs md:text-base font-bold">DOB:</span>
                <span className="text-xs md:text-sm ml-1">{patDob}</span>
              </li>
              {patientId && (
                <li className="inline-flex items-center text-black pl-3 ml-4">
                  <span className="text-xs md:text-base font-bold">ID:</span>
                  <span className="text-xs md:text-sm ml-1">{patientId}</span>
                </li>
              )}
              {patLocation && (
                <li className="inline-flex items-center text-black pl-3 ml-4">
                  <span className="text-xs md:text-base font-bold">Location:</span>
                  <span className="text-xs md:text-sm ml-1">{patLocation}</span>
                </li>
              )}
            </ul>
          </div>

          {/* Action Buttons - Right Aligned */}
          <div className="flex space-x-2 pr-4">
            {access?.new_order === "T" && (
              <button
                className="bg-header_bg rounded py-2 px-4 text-xs font-bold text-white shadow-md leading-6 hover:bg-header_bg/90 transition-colors"
                onClick={() => {
                  dispatch1(updatePatId(patient));
                  dispatch1(updatePatIdForOrder(patient));
                  history.push("/createOrder");
                }}
              >
                ADD ORDER
              </button>
            )}
          </div>
        </div>
        <Modal open={discontinueOpen} onClose={onDisContinueCloseModal} center>
          <div className="pt-10 px-8 pb-4 ">
            <h3
              className="text-lg leading-6 font-medium text-gray-900 text-center"
              id="modal-headline"
            >
              Are you sure you want to discontinue?
            </h3>
            <div className="flex justify-center">
              <button
                onClick={() => {
                  handleDiscontinue();
                  setDiscontinueOpen(false);
                }}
                type="button"
                className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDiscontinueOpen(false);
                }}
                type="button"
                className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <ul
          className={` p-2  mb-0 flex pt-3  ${showList}`}
          role="tablist"
        >  <li className="mr-2  text-center w-36 cursor-pointer">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                (tabIndex === 1 ? "text-black bg-header_bg" : "  bg-menu_active")
              }
              onClick={(e) => {
                e.preventDefault();
                setTabIndex(1);
              }}
              data-toggle="tab"
              role="tablist"
            >
              ACTIVE ORDERS
            </a>
          </li>
          <li className="mr-2 flex-auto text-center w-36 cursor-pointer">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                (tabIndex === 2 ? "text-black bg-header_bg" : "  bg-menu_active")
              }
              onClick={(e) => {
                e.preventDefault();
                setTabIndex(2);
              }}
              data-toggle="tab"
              href="#link2"
              role="tablist"
            >
              INACTIVE ORDERS
            </a>
          </li>
        </ul>
        {tabIndex === 1 && <>
          <div
            className={`p-2 text-xs patientDetails gridList overflow-x-auto  ${showList} `}
          >
            <Table
              className="table-fixed"
              {...tableProps}
              childComponents={{
                cell: {
                  elementAttributes: () => ({
                    style: { textAlign: "center", verticalAlign: "middle" }
                  })
                },
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "select":
                        return <CustomCellNewCheckbox rowData={props} />;
                      case "action":
                        return <CustomCellAction rowData={props} />;
                    }
                  },
                },
                headCell: {
                  content: (props) => {
                    const words = props.column.title ? props.column.title.split(" ") : [];
                    const sortable = props.column.isSortable;
                    const dir = props.column.sortDirection;
                    return (
                      <div
                        style={{
                          textAlign: "center",
                          fontWeight: "inherit",
                          fontSize: "inherit",
                          fontFamily: "inherit",
                          color: "inherit",
                          cursor: sortable ? "pointer" : "default",
                          userSelect: "none",
                        }}
                        onClick={() => {
                          if (sortable) {
                            props.dispatch(updateSortDirection(props.column.key));
                          }
                        }}
                      >
                        {words.map((word, i) => (
                          <span key={i} style={{ display: "block" }}>{word}</span>
                        ))}
                      </div>
                    );
                  },
                },
              }}
              dispatch={dispatch}
            />
          </div>
          <div
            className={`p-2 text-xs patientDetails gridList overflow-x-auto flex ${showList} `}
          >
            {access?.patient_refill === "T" && (
              <button
                className={
                  orderList?.length === 0
                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm mr-4"
                    : "rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm mr-4"
                }
                aria-label="Proceed to Refill"
                onClick={() => handleProceed()}
              >
                Proceed to Refill
              </button>
            )}
            {access?.release_med === "T" && (
              <button
                className={
                  orderList?.length === 0
                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-releaseMedication my-3 focus:outline-none text-sm mr-4"
                    : "rounded font-medium h-10 text-white w-full bg-releaseMedication my-3 focus:outline-none text-sm mr-4"
                }
                aria-label="Release Medication"
                onClick={() => handleReleaseMedication()}
              >
                Release Medication
              </button>
            )}
            {access?.renew_order === "T" && (
              <button
                className={
                  orderList?.length === 0
                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-renewMedication my-3 focus:outline-none text-sm mr-4"
                    : "rounded font-medium h-10 text-white w-full bg-renewMedication my-3 focus:outline-none text-sm mr-4"
                }
                aria-label="Release Medication"
                onClick={() => handleRenewMedication()}
              >
                Renew Orders
              </button>
            )}
            <button
              className={
                orderList?.length === 0
                  ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-rose my-3 mr-4 focus:outline-none text-sm"
                  : "rounded font-medium h-10 text-white w-full bg-rose my-3 focus:outline-none text-sm"
              }
              aria-label="Discontinue"
              onClick={() => setDiscontinueOpen(true)}
            >
              Discontinue
            </button>
          </div>
        </>

        }
        {tabIndex === 2 && <div
          className={`p-2 text-xs patientDetails gridList overflow-x-auto  ${showList} `}
        >
          <Table
            className="table-fixed"
            {...tablePropsInactive}
            childComponents={{
              cell: {
                elementAttributes: () => ({
                  style: { textAlign: "center", verticalAlign: "middle" }
                })
              },
              cellText: {
                content: (props) => {
                },
              },
              headCell: {
                content: (props) => {
                  const words = props.column.title ? props.column.title.split(" ") : [];
                  const sortable = props.column.isSortable;
                    const dir = props.column.sortDirection;
                    return (
                      <div
                        style={{
                          textAlign: "center",
                          fontWeight: "inherit",
                          fontSize: "inherit",
                          fontFamily: "inherit",
                          color: "inherit",
                          cursor: sortable ? "pointer" : "default",
                          userSelect: "none",
                        }}
                        onClick={() => {
                          if (sortable) {
                            props.dispatch(updateSortDirection(props.column.key));
                          }
                        }}
                      >
                        {words.map((word, i) => (
                          <span key={i} style={{ display: "block" }}>{word}</span>
                        ))}
                      </div>
                    );
                },
              },
            }}
            dispatch={dispatchInactive}
          />
        </div>}
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(PatientDetails)
);